var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"72","height":"72","rx":"8","fill":"#ECF1F1","key":0}),React.createElement("path",{"d":"M26.7152 26.8333L34.7463 34.6996C35.4429 35.3818 36.5571 35.3818 37.2537 34.6996L45.2848 26.8333H26.7152ZM47.6667 29.1663L39.5861 37.0809C37.5937 39.0325 34.4063 39.0325 32.4139 37.0809L24.3333 29.1663V43.375C24.3333 44.3645 25.1355 45.1667 26.125 45.1667H45.875C46.8645 45.1667 47.6667 44.3645 47.6667 43.375V29.1663ZM26.125 23.5H45.875C48.7055 23.5 51 25.7945 51 28.625V43.375C51 46.2055 48.7055 48.5 45.875 48.5H26.125C23.2945 48.5 21 46.2055 21 43.375V28.625C21 25.7945 23.2945 23.5 26.125 23.5Z","fill":"#404040","key":1})]);
}

Email.defaultProps = {"width":"72","height":"72","viewBox":"0 0 72 72","fill":"none"};

module.exports = Email;

Email.default = Email;
